import { useState } from "react";
import { useRouter } from "next/router";
import { Button, Modal } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { closePost } from "~/redux/actions/post";

function PostStatusToggleAddon(props) {
  const post = props.post;
  const refund = (post.category && post.category.post_ele_refund) || 0;
  const [closed, setClosed] = useState(post.closed);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const router = useRouter();

  const isJob = post.category.code === "jd" || post.category.code === "talent";

  const handleToggle = () => {
    if (closed) {
      // redirect 到新建 post 页面
      const newPostUrl = isJob ? "/jobs/new" : "/posts/new";
      router.push({
        pathname: newPostUrl,
        query: {
          original_id: post.id,
          c: post.category.code,
        },
      });
      return;
    }
    Modal.confirm({
      title: "确认要结束招聘吗？",
      content: (
        <p>
          {refund > 0 ? (
            <p>
              结束招聘将返还 <span className="text-primary">{refund}</span> 电量
            </p>
          ) : (
            "结束招聘后您还可以重新发布，获取更多曝光"
          )}
        </p>
      ),
      onOk: async () => {
        setIsSubmitting(true);
        try {
          await props.closePost(props.token, post.id, () => {
            setClosed(true);
          });
        } finally {
          setIsSubmitting(false);
        }
      },
    });
  };

  return (
    <div className="py-20 text-center">
      <Button
        type="primary"
        loading={isSubmitting}
        onClick={handleToggle}
      >
        {closed ? "重启招聘" : "结束招聘"}
      </Button>
      <div className="mt-10 text-sm text-secondary">
        {closed
          ? "再次发布以获取更多曝光"
          : refund && refund > 0
            ? `操作后奖励 ${refund} 电量`
            : ""}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closePost,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PostStatusToggleAddon);
